/* ===== SAFETY PATCH: Privacy, Mengenrabatt-Text, Gallery, Accordion ===== */
(() => {
  // ---------- PRIVACY / CHECKOUT-SPERRE ----------
  const privacyRoots = Array.from(document.querySelectorAll('.privacy-cart'));

  const setCheckoutDisabled = (originEl, disabled) => {
    const ctx = originEl?.closest?.('.cart-drawer, .cart') || document;
    const btn = ctx.querySelector('button[name="checkout"]');
    if (btn) btn.disabled = !!disabled;
  };

  const onPrivacyClick = (ev) => {
    const t = ev.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches('.privacy-cart #privacy, .privacy-cart #privacy_drawer')) return;
    setCheckoutDisabled(t, !t.checked);
  };

  if (privacyRoots.length) {
    privacyRoots.forEach((root) => {
      const privacyDrawer = root.querySelector('#privacy_drawer');
      if (privacyDrawer && privacyDrawer.checked) privacyDrawer.checked = false;
      const anyChecked = !!root.querySelector('#privacy:checked, #privacy_drawer:checked');
      setCheckoutDisabled(root, !anyChecked);
    });
    document.addEventListener('click', onPrivacyClick, { passive: true });
  }

  // ---------- MENGENRABATT-TEXT ----------
  setTimeout(() => {
    const specTextElement = document.querySelector('#quantity-discount-app .spec_text');
    if (specTextElement && document.documentElement.lang === 'en') {
      let html = specTextElement.innerHTML;
      html = html.replace('Ab', 'For orders of');
      html = html.replace('Stück erhalten Sie einen Rabatt von', 'or more, you will receive a discount of');
      html = html.replace('off', 'per item');
      specTextElement.innerHTML = html;
    }
  }, 2000);

  // ---------- GALLERY / MEDIA-CAROUSEL ----------
  const initGallery = () => {
    const gallery = document.querySelector('media-carousel');
    if (!gallery) return;
    const slides = gallery.querySelectorAll('.product-gallery__media');
    if (!slides.length) return;

    const leftArrow = document.querySelector('.product-gallery__arrow--left');
    const rightArrow = document.querySelector('.product-gallery__arrow--right');

    const getCurrentIndex = () =>
      Array.from(slides).findIndex(slide => slide.classList.contains('is-selected'));

    const hasSelectMethod = typeof gallery.select === 'function';

    const goToIndex = (idx) => {
      if (idx < 0 || idx >= slides.length) return;
      if (hasSelectMethod) {
        try { gallery.select(idx); } catch (e) {}
      } else {
        const cur = getCurrentIndex();
        if (cur >= 0) slides[cur].classList.remove('is-selected');
        slides[idx].classList.add('is-selected');
      }
    };

    if (leftArrow) leftArrow.addEventListener('click', () => {
      const cur = getCurrentIndex();
      const next = cur > 0 ? cur - 1 : slides.length - 1;
      goToIndex(next);
    }, { passive: true });

    if (rightArrow) rightArrow.addEventListener('click', () => {
      const cur = getCurrentIndex();
      const next = cur >= 0 ? (cur + 1) % slides.length : 0;
      goToIndex(next);
    }, { passive: true });
  };

  // ---------- ACCORDION ----------
  const initAccordion = () => {
    const buttons = document.querySelectorAll('.accordion-title');
    if (!buttons.length) return;
    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const item = this.closest('.accordion-item');
        if (item) item.classList.toggle('active');
      }, { passive: true });
    });
  };

  // ---------- INITIALISIERUNG ----------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGallery();
      initAccordion();
    });
  } else {
    initGallery();
    initAccordion();
  }
})();











